import { client } from "@/main";

export default function (
  opportunite,
  factures,
  entrepriseSirenIdOctave,
  parametresUrlMarketing,
  parametresUrlParrainage
) {
  let formData = new FormData();

  if (entrepriseSirenIdOctave !== null) {
    formData.append('entrepriseSirenIdOctave', entrepriseSirenIdOctave);
  }

  if (opportunite.accesPce === false) {
    opportunite.compteursGaz = [];
  }

  if (opportunite.accesRae === false) {
    opportunite.compteursElectriques = [];
  }

  formData.append("opportunite", JSON.stringify(opportunite));
  formData.append("parametresUrlMarketing", JSON.stringify(parametresUrlMarketing ?? {}));
  formData.append('parametresUrlParrainage', JSON.stringify(parametresUrlParrainage ?? {}));

  factures.forEach((facture) => {
    if (facture) {
      formData.append("factures[]", facture);
    }
  })

  return client
    .post(`/api/v1/opportunite/soumettre`, formData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new (class extends Error {
        codeErreur = null;

        constructor(message, codeErreur) {
          super(message);
          this.codeErreur = codeErreur;
        }
      })(error.message, error.response.status);
    });
}
